import { Flex, Text } from '@chakra-ui/react'
import * as T from '../../../components/Table'
import { format, isValid } from 'date-fns'
import { cnpjMask } from '../../../utils/cnpjMask'
import { formatPrice } from '../../../utils/formatPrice'
import { FaCheckCircle } from 'react-icons/fa'
import { user } from '../../../helpers/user'
import { lazy, Suspense } from 'react'

const EditarCliente = lazy(() => import('./EditarCliente').then((module) => ({ default: module.EditarCliente })))
const AtivarCliente = lazy(() => import('./AtivarCliente').then((module) => ({ default: module.AtivarCliente })))

export function ItemContact({ cliente }) {
  const hasHour = isValid(new Date(cliente.data_cadastro)) && format(new Date(cliente.data_cadastro), 'HH:mm:ss') !== '00:00:00'
  const userPermission = user?.codigo_usuario !== 30 ? user?.codigo_usuario : 0

  return (
    <T.Tr key={cliente.codigo_parceiro + cliente.codigo_contato}>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text>{cliente.data_cadastro ? format(new Date(cliente.data_cadastro), 'dd/MM/yyyy') : ''}</Text>
        {hasHour && <Text>{cliente.data_cadastro ? format(new Date(cliente.data_cadastro), 'HH:mm:ss') : ''}</Text>}
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text textTransform="capitalize">{cliente.nome_vendedor?.toLowerCase()}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text textTransform="capitalize">
          {cliente.codigo_parceiro} - {cliente.nome_parceiro?.trim()?.toLowerCase()}
        </Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text>{cnpjMask(cliente?.cnpj?.trim())}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text
          color="#378BBF"
          fontWeight="bold"
          textDecor="underline"
          as={'a'}
          href={`/propostas/${userPermission}?acompanhamento_proposta=s&cliente_orcamento=${cliente.codigo_parceiro}`}
          target="_blank"
          rel="noreferrer"
        >
          {cliente.quantidade_orcamentos}
        </Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text
          color="#378BBF"
          fontWeight="bold"
          textDecor="underline"
          as={'a'}
          href={`/pedidos-vendedor/${userPermission}?pedidos=true&cliente_pedido=${cliente.codigo_parceiro}`}
          target="_blank"
          rel="noreferrer"
        >
          {cliente.quantidade_pedidos}
        </Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text>{formatPrice(cliente.valor_orcamento)}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text>{cliente.origem_orcamento_desc?.trim()?.toLowerCase()}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text>{cliente.nome_cidade?.trim()?.toLowerCase()}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #ccc!important" py={1}>
        <Text>{cliente.uf?.trim()}</Text>
      </T.Td>
      <T.Td textAlign="center" borderRight="1px solid #ccc!important" py={1}>
        <Flex alignItems="center" justifyContent="center">
          {cliente.cliente_especial?.trim() === 'S' ? <FaCheckCircle size="18" color="#FFA200" /> : null}
        </Flex>
      </T.Td>
      <T.Td py={1}>
        <Suspense fallback={<div>Carregando...</div>}>
          <EditarCliente dataClient={cliente} />
        </Suspense>
      </T.Td>
      <T.Td py={1}>
        <Suspense fallback={<div>Carregando...</div>}>
          <AtivarCliente dataClient={cliente} />
        </Suspense>
      </T.Td>
    </T.Tr>
  )
}
